import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { FormControl, FormGroup } from "@angular/forms";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/content-search/models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            homePageId: new FormControl<string>(initialSearchParams.homePageId),
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            sortOption: new FormControl<string>(initialSearchParams.sortOption),
            searchText: new FormControl<string>(initialSearchParams.searchText),
            topics: new FormControl<Array<string>>(initialSearchParams.topics),
            contentTypes: new FormControl<Array<string>>(initialSearchParams.contentTypes),
            audience: new FormControl<Array<string>>(initialSearchParams.audience)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>; }
    public get homePageId(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("homePageId")) as FormControl<string>; }
    public get sortOption(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("sortOption")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>; }
    public get topics(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("topics")) as FormControl<Array<string>>; }
    public get contentTypes(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("contentTypes")) as FormControl<Array<string>>; }
    public get audience(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("audience")) as FormControl<Array<string>>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            topics: this.initialFormState.topics,
            contentTypes: this.initialFormState.contentTypes,
            audience: this.initialFormState.audience
        });
    }

    public searchByFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1
        });
    }
}
